export default __webpack_public_path__ + "static/media/assign_Transfer_job.d6334f13.svg";